var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{class:['save-alert', `bg-${_vm.variant}-alert`],attrs:{"show":_vm.showAlert,"fade":"","variant":_vm.variant}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }